export default {
    language: 'Sprache',
    activeOrganisation: 'Aktive Organisation',
    organisation: 'Organisation',
    roles: 'Rollen'
}
